<script>
import axios from "axios";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: "EditUser",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  props: {
    roleOptions: {
      type: Array,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  emits: ['closed'],
  data() {
    return {
      selectHeight: '120px',
      apiUrl: "/api/user/",
      formData: {
        Id: null,
        Email: null,
        Password: null,
        Role: null,
      },
      textareaData: '',
      error: '',
      loader: null,
    }
  },
  methods: {
    getUser() {
      let loader = this.$loading.show();
      this.error = '';
      axios.get(`${this.apiUrl}${this.userId}`, this.authRespConf())
          .then(res => {
            loader.hide();
            if (res !== null && res !== undefined) {
              if (res.data.message !== null && res.data.message !== undefined) {
                this.$bvToast.toast(res.data.message, {
                  title: 'Error',
                  autoHideDelay: 5000,
                  variant: 'danger',
                  appendToast: true
                })
                return
              }
            }
            this.formData.Id = res.data.data.Id
            this.formData.Email = res.data.data.Email
            this.formData.Role = res.data.data.Role
          })
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true);
          });
    },
    submitForm() {
      let loader = this.$loading.show();
      this.error = '';
      axios.patch(this.apiUrl, {...this.formData}, this.authRespConf())
          .then(res => {
            loader.hide();
            if (res !== null && res !== undefined) {
              if (res.data.message !== null && res.data.message !== undefined) {
                this.$bvToast.toast(res.data.message, {
                  title: 'Error',
                  autoHideDelay: 5000,
                  variant: 'danger',
                  appendToast: true
                })
                return
              }
            }
            this.$bvToast.toast('', {
              title: 'User added successfully',
              autoHideDelay: 5000,
              variant: 'success',
              appendToast: true
            })
            this.closeModal()
          })
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true);
          });
    },
    opened() {
      this.getUser()
    },
    closeModal() {
      this.formData = {
        Role: null,
        Email: null,
        Password: null,
      }
      this.loaded = false
      this.$modal.hide('editUser')
    },
  },

}
</script>

<template>
  <modal
      :draggable="true"
      :resizable="true"
      :clickToClose="false"
      name='editUser'
      :min-width="425"
      :width="850"
      :min-height="(500 / 2)"
      :height="500"
      :scrollable="true"
      @closed="$emit('closed')"
      @opened="opened"
      class="modalBox"
      :style="{'--selectHeight': selectHeight}"
  >
    <div class="window-header">
      New User
      <a href="javascript:void(0)" class="close-modal pull-right" @click="closeModal">
        <i class="fa fa-times"></i>
      </a>
    </div>
    <div class="modal-body" ref="modalBox">
      <div class="page-modal" style="background:white">
        <form ref="form" class="form-horizontal" @submit.prevent="submitForm">
          <div class="row">
            <div class="col-sm-12">
              <label class="col-form-label" for="email">Email <span class="text-danger">*</span></label>
              <input
                  type="text"
                  required
                  class="form-control"
                  placeholder="N/A"
                  name="email"
                  v-model="formData.Email">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="role">Role <span class="text-danger">*</span></label>
              <v-select :options="roleOptions"
                        :reduce="role => role.value"
                        v-model="formData.Role"
                        clearable
                        required
                        maxHeight="50px"
                        placeholder="N/A"
                        name="role"
                        inputId="valueType"/>
            </div>
            <div class="col-sm-12">
              <label class="col-form-label" for="password">Password <span class="text-danger">*</span></label>
              <input
                  type="password"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="password"
                  v-model="formData.Password">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mt-2"><p class="text-danger">* Required fields</p></div>
            <div class="col-sm-8 mt-2" style="text-align:right">
              <button type="button" @click="closeModal" class="btn btn-danger text-white mr-2">Cancel
              </button>
              <button type="submit" class="btn btn-primary">Create</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<style scoped>

</style>